const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

class PlainClipboard extends Clipboard {
  onPaste (e) {
    e.preventDefault()
    const range = this.quill.getSelection();
    if (range == null) return;
    let originaltext = e.clipboardData.getData('text/plain').replace(/\t/g, '').trim();
    
    //let texts = text.split('\r\n');
    let texts = [];
    let formats = [];
    //let format = this.quill.getFormat();
    let delta;
    let index = range.index;

    var div = document.createElement('div');
    div.innerHTML = e.clipboardData.getData('text/html');
    
    //fx.dom.css(this._editor.root, {"font-family":"Open Sans", "text-align":"left", "font-size": lowest + "px", "color":"#000"});
    let children = div.children;
    for (let i = 0; i < children.length; i++)
    {
      /*if (  children[i].tagName !="P" && 
            children[i].tagName !="DIV" && 
            children[i].tagName !="H1" && 
            children[i].tagName !="H2" && 
            children[i].tagName !="H3" && 
            children[i].tagName !="H4" && 
            children[i].tagName !="H5" && 
            children[i].tagName !="H6" &&
            children[i].tagName !="UL" &&
            children[i].tagName !="LI" && 
            children[i].tagName !="LINK")
        continue;*/

      if (children[i].tagName == "META" || children[i].tagName == "STYLE")
        continue;
        

      let format = { size: 6, bold: false, italic: false, color: 'black', font: "Open Sans", align: "left"};

      format.font = children[i].style.fontFamily || format.font;
      format.size = children[i].style.fontSize || format.size;
      format.color = children[i].style.color || format.color;
      format.bold = (children[i].style.fontWeight.includes("bold") || children[i].style.fontWeight > 400) || format.bold;
      format.italic = (children[i].style.fontStyle == "italic") || format.italic;
      format.align = children[i].style.textAlign || format.align;

      if (children[i].children.length > 0)
      {
        let childs = children[i].children;
        for (let i = 0; i < childs.length; i++)
        {
          format.font = childs[i].style.fontFamily || format.font;
          format.size = childs[i].style.fontSize || format.size;
          format.color = childs[i].style.color || format.color;
          format.bold = (childs[i].style.fontWeight.includes("bold") || childs[i].style.fontWeight > 400 || childs[i].tagName == "STRONG" ||  childs[i].tagName == "B") || format.bold;
          format.italic = (childs[i].style.fontStyle == "italic") || format.italic;
          format.align = childs[i].style.textAlign || format.align;
        }
      }

      if (typeof format.size == "string" && format.size.includes("px"))
        format.size = Math.max(6, Math.round(parseInt(format.size) / 2) );
      
      let Font = Quill.import('attributors/style/font');
      
      for(let i = 0; i < Font.whitelist.length; i++)
      {
        if (format.font.includes(Font.whitelist[i]))
        {
          format.font = Font.whitelist[i];
          break;
        }
      }

      if (!format.font.includes("Open Sans"))
         format.bold = false;

      let text = children[i].innerText.trim();
      if (text)
      {
        texts.push(text);
        formats.push(format);
      }
    }
    
    if (texts.length == 0 && originaltext != "")
    {
        texts.push(originaltext);
        formats.push({ size: 6, bold: false, italic: false, color: 'black', font: "Open Sans", align: "left"});
    }

    // delete selection
    delta = new Delta().retain(range.index).delete(range.length);
    this.quill.updateContents(delta, 'silent');

    for(let i = 0; i < texts.length; i++)
    {
      if (i < texts.length - 1)
        texts[i] = texts[i] + '\n';

      delta = new Delta().retain(index)
                         .insert(texts[i], formats[i]);
    
      index += texts[i].length;
      
      this.quill.updateContents(delta, 'silent');
    }
    this.quill.setSelection(index, 0, 'silent');
    this.quill.scrollIntoView();
  }
}

Quill.register('modules/clipboard', PlainClipboard, true)